import Vue from 'vue'
import store from '@/store'
import { map, join } from 'ramda'
import Global from '@/global'
import axios from 'axios'
import { format, fromUnixTime } from 'date-fns'
import toClipboard from 'copy-text-to-clipboard'
import i18n from '@/i18n/index.js'
import { LANGUAGE } from './constant'

export const copyToClipboard = (text) => {
  toClipboard(text)
  Vue.prototype.$message.success(i18n.tc('inviteLink.CollaborationCopied'))
}

export async function fetchShortUrl(conferenceId){
  const { origin } = location
  const invitationUrl = Global.resolvePath('/hiapigw/qrcode/openApp?url=', origin)

  const appUrl = `hileia://platformapi/startapp?action=join_conference&conferenceId=${conferenceId}`
  const base64EncodedAppUrl = Global.base64Encode(appUrl)

  const response = await axios.get('/api/short', { params: { url: invitationUrl + base64EncodedAppUrl } })
  if ((response?.data?.retCode ?? '') === 0) {
    return response?.data?.shortUrl ?? ''
  } else {
    return ''
  }
}

export function getFormatText({ theme, tags, beginTime, endTime, shortUrl }){
  const tagArray = map(tag => tag.name, tags || [])
  const begin = fromUnixTime(beginTime)
  const end = fromUnixTime(endTime)
  const beginTimeFormat = format(begin, i18n.locale === LANGUAGE.CHINESE ? 'yyyy年MM月dd日 HH:mm' : 'yyyy-MM-dd HH:mm')
  const endTimeFormat = format(end, begin.getDate() === end.getDate() ? 'HH:mm' : (i18n.locale === LANGUAGE.CHINESE ? 'yyyy年MM月dd日 HH:mm' : 'yyyy-MM-dd HH:mm'))

  const line1 = i18n.tc('inviteLink.InvitesCollaborateUseHiLeia').replace('XX', store.state.userInfo.name)
  const line2 = `【${i18n.tc('home.Theme')}】 ${theme}`
  const line3 = `【${i18n.tc('home.Type')}】 ${join('、', tagArray)}`
  const line4 = `【${i18n.tc('common.Time')}】 ${beginTimeFormat} - ${endTimeFormat}`
  const line5 = `【${i18n.tc('common.Link')}】 ${origin}${shortUrl}`
  return join('\n', [line1, line2, line3, line4, line5])
}

export async function getFullFormatText({ theme, tags, beginTime, endTime, conferenceId }) {
  const shortUrl = await fetchShortUrl(conferenceId)
  if (shortUrl) {
    return getFormatText({ theme, tags, beginTime, endTime, shortUrl })
  }
  return ''
}

export async function copyInvitationLink({ theme, tags, beginTime, endTime, conferenceId, successMsg = i18n.tc('inviteLink.CollaborationCopied') }) {
  const shortUrl = await fetchShortUrl(conferenceId)
  if (shortUrl) {
    const content = getFormatText({ theme, tags, beginTime, endTime, shortUrl })
    toClipboard(content)
    Vue.prototype.$message.success(successMsg)
  } else {
    Vue.prototype.$message.error(i18n.tc('inviteLink.CollaborationCopyFailed'))
  }
}
